import { httpCodeExamples } from 'components/CodeExamples/http-code-examples'
import { stringifyWithIndent } from 'components/CodeExamples/stringify-with-indent'
import ExampleCodeBlock from 'components/Docs/ExampleCodeBlock'

export function DataSourceApiMatchRecordCodeExample({
  id,
  input,
}: {
  id: string
  input: any
}) {
  const js = `await integrationApp
  .dataSourceInstance('${id}')
  .matchRecord(${stringifyWithIndent(input)})
`
  const { curl } = httpCodeExamples(
    `/data-source-instances/${id}/collection/match`,
    { method: 'POST', body: JSON.stringify(input) },
  )

  return (
    <ExampleCodeBlock
      customCodes={{ js, curl }}
      run={async ({ integrationApp }) =>
        await integrationApp.dataSourceInstance(id).matchRecord(input)
      }
    />
  )
}
